import React, { useState, useEffect, useRef } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import '../../assets/css/layouts/Layout.css';

const Layout = ({ children }) => {
  const [sidebarVisible, setSidebarVisible] = useState(window.innerWidth >= 768);
  const sidebarRef = useRef(null);

  // Automatically hide sidebar on mobile
  useEffect(() => {
    const handleResize = () => {
      setSidebarVisible(window.innerWidth >= 768);
    };

    const handleClickOutside = (e) => {
      if (window.innerWidth < 768 && sidebarVisible) {
        if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
          setSidebarVisible(false);
        }
      }
    };

    window.addEventListener('resize', handleResize);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [sidebarVisible]);

  const toggleSidebar = () => setSidebarVisible(prev => !prev);

  return (
    <div className="layout d-flex">
      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`sidebar-container ${sidebarVisible ? 'show' : 'hide'}`}
      >
        <Sidebar />
      </div>

      {/* Main content */}
      <div className={`main-content flex-grow-1 ${sidebarVisible ? 'with-sidebar' : 'full-width'}`}>
        <Navbar toggleSidebar={toggleSidebar} />
        <div className="p-3">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
